import { FundingOpportunities } from '@platform/client';
import { DatePickerWithTimezone, Input, Modal } from '@platform/components';
import { useQueryClient } from '@tanstack/react-query';
import { FundingOpportunity } from '@platform/client/schemas';
import { useState } from 'react';

interface UpdateFundingOpportunityModalProps {
  isOpen: boolean;
  onClose: () => void;
  fundingOpportunity: FundingOpportunity;
  page?: number;
  limit?: number;
}

export const UpdateFundingOpportunityModal = (props: UpdateFundingOpportunityModalProps) => {
  const { fundingOpportunity, isOpen, onClose, page, limit } = props;

  const [title, setTitle] = useState(fundingOpportunity.title);
  const [description, setDescription] = useState(fundingOpportunity.description);
  const [date, setDate] = useState(new Date(fundingOpportunity.date));
  const [link, setLink] = useState(fundingOpportunity.link || '');

  const queryClient = useQueryClient();

  const submitFundingOpportunity = FundingOpportunities.useUpdateFundingOpportunity({
    mutation: {
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: FundingOpportunities.getGetFundingOpportunitiesAdminQueryKey({
            limit: limit || 0,
            page: page || 0,
          }),
        });
      },
    },
  });

  const updateFundingOpportunity = () => {
    submitFundingOpportunity.mutate({
      data: {
        id: fundingOpportunity.id,
        title,
        description,
        date: date.toISOString(),
        link,
      },
    });

    closeModal();
  };

  const closeModal = () => {
    onClose();
    setTitle('');
    setDescription('');
    setDate(new Date());
    setLink('');
  };

  return (
    <Modal
      variant='dialog'
      title='Update Funding Opportunity'
      isOpen={isOpen}
      headerDivision='divider'
      ignoreExtraPadding={true}
      onClose={closeModal}
      primaryCTA={{
        text: 'Update Funding Opportunity',
        callback: updateFundingOpportunity,
      }}
      secondaryCTA={{
        text: 'Cancel',
        callback: closeModal,
      }}
    >
      <div className='md:w-[460px]'>
        <div className='flex flex-col gap-4 w-full'>
          <Input
            label='Title'
            type='inline'
            value={title}
            onChange={(e) => setTitle(e.target.value)}
          ></Input>
          <Input
            label='Description'
            type='multiline'
            value={description}
            onChange={(e) => setDescription(e.target.value)}
          />
          <Input
            label='Link'
            type='inline'
            value={link}
            onChange={(e) => setLink(e.target.value)}
          />
          <DatePickerWithTimezone date={date} setDate={(newDate) => setDate(newDate)} />
        </div>
      </div>
    </Modal>
  );
};
